import { Row, Col } from "antd";
import { withTranslation, TFunction } from "react-i18next";
import { SvgIcon } from "../../common/SvgIcon";
import Container from "../../common/Container";
import { FooterSection, CopyrightText, ImageContainer, LegalLinks } from "./styles";
import { Link } from "react-router-dom";

const Footer = ({ t }: { t: TFunction }) => {
  return (
    <>
      <FooterSection>
        <Container>
        <Row justify="center" align="middle" style={{ paddingTop: "3rem" }}>
            <Col>
              <CopyrightText>
                Copyright © 2025 Quintela Transportation - All rights reserved.
              </CopyrightText>
              <LegalLinks>
                <Link to="/privacy-policy">Privacy Policy</Link>
              </LegalLinks>
            </Col>
          </Row>
          <ImageContainer>
            <a
              href="https://johmp.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <SvgIcon
                src="johmp.svg"
                aria-label="homepage"
                width="50px"
                height="45px"
              />
            </a>
          </ImageContainer>

        </Container>
      </FooterSection>
    </>
  );
};

export default withTranslation()(Footer);
